import Cookies from "js-cookie";
import { getFormationVideos } from "./ApiCalls/formationVideo/getFormationVideos";
import { getVimeoVideos } from "./ApiCalls/formationVideo/getVimeoVideos";

export async function GetFormationVideosService() {
  let language = Cookies.get("myreportin_language")
  
  try {
    const formationVideos = await getFormationVideos(language);
    const vimeoData = [];

    // Usar un bucle for...of para manejar las promesas adecuadamente
    for (const formationVideo of formationVideos) {
      const videoData = await getVimeoVideos(formationVideo.url);

      vimeoData.push(
        { 
            thumbnail: videoData.pictures.sizes[4].link, 
            video: videoData.embed.html, 
            title: videoData.name, 
            firstVideo: formationVideo.firstVideo
        }
        );
    }
    
    return vimeoData; // Suponiendo que quieras retornar vimeoData en lugar de formationVideos
  } catch (error) {
    // Manejar el error
    throw error;
  }
}
